import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { useMutation } from '@vue/apollo-composable';
import { computed, defineComponent, ref, watch } from 'vue';
import CustomComparisonModal from '~/components/impact-goal/edit/CustomComparisonModal.vue';
import IdematComparisonModal from '~/components/impact-goal/edit/IdematComparisonModal.vue';
import UPSERT_EMISSION_SOURCE from '~/graphql/mutations/impact-goal/UpsertEmissionSource.gql';
import { renderTrustedMarkdown } from '~/functions/markdown';
export default defineComponent({
  name: 'YourSolutionEmissionSourceForm',
  components: {
    CustomComparisonModal: CustomComparisonModal,
    IdematComparisonModal: IdematComparisonModal
  },
  props: {
    toEditEmissionSource: {
      type: Object,
      required: true
    },
    impactSolution: {
      type: Object,
      required: true
    },
    resetSolutionDialogForm: {
      type: Number,
      required: false,
      default: 0
    }
  },
  setup: function setup(props, context) {
    var route = useRoute();
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var _useMutation = useMutation(UPSERT_EMISSION_SOURCE),
      upsertEmissionSourceMutation = _useMutation.mutate;
    var emissionSource = ref(_objectSpread({}, props.toEditEmissionSource));
    var resetSolutionForm = function resetSolutionForm() {
      emissionSource.value = _objectSpread({}, props.toEditEmissionSource);
      nextTick(function () {
        // Any code here will execute after the emissionSource.value updates have been
        // reacted to by Vue's reactivity system and the DOM has been updated accordingly.
        // This is used because, if checkbox changes trigger other changes in emissionSource,
        // those changes will have taken effect by the time the code here runs.
        emissionSource.value.solutionConceptName = props.toEditEmissionSource.solutionConceptName;
        emissionSource.value.solutionEvidence = props.toEditEmissionSource.solutionEvidence;
        emissionSource.value.solutionGhgFactor = props.toEditEmissionSource.solutionGhgFactor;
        emissionSource.value.solutionConsumption = props.toEditEmissionSource.solutionConsumption;
        emissionSource.value.solutionConsumption = props.toEditEmissionSource.solutionConsumption;
      });
    };
    var bothCheckbox = ref(emissionSource.value.solutionReducesConsumption && emissionSource.value.solutionReducesGhgFactor);
    var amountDisabled = ref(true);
    if (emissionSource.value.solutionReducesConsumption === true) {
      amountDisabled.value = false;
    }
    var previousConsumption = ref(emissionSource.value.solutionReducesConsumption);
    var previousGhgFactor = ref(emissionSource.value.solutionReducesGhgFactor);
    var copyBaselineToSolution = function copyBaselineToSolution() {
      emissionSource.value.solutionConceptName = emissionSource.value.baselineConceptName;
      emissionSource.value.solutionEvidence = emissionSource.value.baselineEvidence;
      emissionSource.value.solutionGhgFactor = emissionSource.value.baselineGhgFactor;
      emissionSource.value.solutionUnitName = emissionSource.value.baselineUnitName;
      emissionSource.value.customSolutionConcept = emissionSource.value.customBaselineConcept;
    };
    var clearSolutionGhgFields = function clearSolutionGhgFields() {
      emissionSource.value.solutionConceptName = null;
      emissionSource.value.solutionEvidence = null;
      emissionSource.value.solutionGhgFactor = null;
      emissionSource.value.solutionUnitName = null;
      emissionSource.value.customSolutionConcept = null;
    };
    var updateFormFields = function updateFormFields(consumption, ghgFactor) {
      var consumptionTicked = !previousConsumption.value && consumption;
      var consumptionUnticked = previousConsumption.value && !consumption;
      var ghgFactorTicked = !previousGhgFactor.value && ghgFactor;
      var ghgFactorUnticked = previousGhgFactor.value && !ghgFactor;
      if (consumptionUnticked) {
        emissionSource.value.solutionConsumption = emissionSource.value.baselineConsumption;
        amountDisabled.value = true;
      }
      if (ghgFactorUnticked) {
        copyBaselineToSolution();
      }
      if (consumptionTicked) {
        emissionSource.value.solutionConsumption = null;
        amountDisabled.value = false;
        if (!ghgFactor) {
          copyBaselineToSolution();
        }
      }
      if (ghgFactorTicked) {
        clearSolutionGhgFields();
        if (!consumption) {
          emissionSource.value.solutionConsumption = emissionSource.value.baselineConsumption;
        }
      }
      previousConsumption.value = consumption;
      previousGhgFactor.value = ghgFactor;
    };
    watch(function () {
      return [emissionSource.value.solutionReducesConsumption, emissionSource.value.solutionReducesGhgFactor];
    }, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        consumption = _ref2[0],
        ghgFactor = _ref2[1];
      bothCheckbox.value = consumption && ghgFactor;
      updateFormFields(consumption, ghgFactor);
    });
    watch(bothCheckbox, function (newValue) {
      if (newValue) {
        emissionSource.value.solutionReducesConsumption = true;
        emissionSource.value.solutionReducesGhgFactor = true;
      } else if (emissionSource.value.solutionReducesConsumption && emissionSource.value.solutionReducesGhgFactor) {
        emissionSource.value.solutionReducesConsumption = false;
        emissionSource.value.solutionReducesGhgFactor = false;
      }
    });
    var resetSolutionDialogFormRef = toRef(props, 'resetSolutionDialogForm');
    watch(resetSolutionDialogFormRef, function () {
      resetSolutionForm();
    });
    var handleSelectedSolutionFactor = function handleSelectedSolutionFactor(item) {
      emissionSource.value.solutionGhgFactor = item.factor;
      emissionSource.value.solutionUnitName = item.unit;
      emissionSource.value.solutionEvidence = item.evidence;
      emissionSource.value.solutionConceptName = item.name;
      emissionSource.value.customSolutionConcept = false; // IDEMAT selection = from database
    };
    var handleCustomSelectedSolutionFactor = function handleCustomSelectedSolutionFactor(item, dialog) {
      emissionSource.value.solutionGhgFactor = item.factor;
      emissionSource.value.solutionEvidence = item.evidence;
      emissionSource.value.solutionConceptName = item.name;
      emissionSource.value.solutionUnitName = item.unit;
      emissionSource.value.customSolutionConcept = true; // Custom entry = manual
      dialog.value = false;
    };
    var upsertEmissionSource = function upsertEmissionSource(fields) {
      upsertEmissionSourceMutation({
        input: _objectSpread({
          ghgSavingPotentialId: props.impactSolution.ghgSavingPotentialId,
          ventureId: ventureId.value
        }, fields)
      });
    };
    var getFactorText = function getFactorText(emissionSource) {
      if (emissionSource.solutionGhgFactor) {
        return emissionSource.solutionGhgFactor + ' kg CO2e / ' + emissionSource.solutionUnitName;
      } else {
        return '';
      }
    };
    var cancel = function cancel() {
      resetSolutionForm();
      context.emit('close');
    };
    var saveAndClose = function saveAndClose() {
      var upsertDocument = {
        id: emissionSource.value.id,
        solutionUnitName: emissionSource.value.solutionUnitName,
        baselineUnitName: emissionSource.value.baselineUnitName,
        // @deprecated Use solutionAssumption instead
        howSolutionWorks: emissionSource.value.howSolutionWorks,
        solutionConceptName: emissionSource.value.solutionConceptName,
        solutionConsumption: Number(emissionSource.value.solutionConsumption),
        solutionGhgFactor: Number(emissionSource.value.solutionGhgFactor),
        solutionReducesGhgFactor: emissionSource.value.solutionReducesGhgFactor,
        solutionEvidence: emissionSource.value.solutionEvidence,
        solutionReducesConsumption: emissionSource.value.solutionReducesConsumption,
        solutionAssumption: emissionSource.value.solutionAssumption
      };
      if (emissionSource.value.customSolutionConcept !== undefined) {
        upsertDocument.customSolutionConcept = emissionSource.value.customSolutionConcept;
      }
      if (emissionSource.value.customBaselineConcept !== undefined) {
        upsertDocument.customBaselineConcept = emissionSource.value.customBaselineConcept;
      }
      upsertEmissionSource(_objectSpread({}, upsertDocument));
      context.emit('close');
    };
    var impactProfile = computed(function () {
      var _props$impactSolution, _props$impactSolution2;
      return (_props$impactSolution = props.impactSolution) === null || _props$impactSolution === void 0 ? void 0 : (_props$impactSolution2 = _props$impactSolution.ghgSavingPotential) === null || _props$impactSolution2 === void 0 ? void 0 : _props$impactSolution2.impactProfileKind;
    });
    var disableSaveButton = computed(function () {
      var consumption = emissionSource.value.solutionConsumption;
      return !(consumption || consumption === 0);
    });
    var rules = {
      required: function required(value) {
        return value !== undefined && value !== null && value !== '' || 'Field is required';
      }
    };
    return {
      upsertEmissionSourceMutation: upsertEmissionSourceMutation,
      renderTrustedMarkdown: renderTrustedMarkdown,
      handleSelectedSolutionFactor: handleSelectedSolutionFactor,
      handleCustomSelectedSolutionFactor: handleCustomSelectedSolutionFactor,
      saveAndClose: saveAndClose,
      getFactorText: getFactorText,
      cancel: cancel,
      ventureId: ventureId,
      emissionSource: emissionSource,
      bothCheckbox: bothCheckbox,
      impactProfile: impactProfile,
      amountDisabled: amountDisabled,
      rules: rules,
      disableSaveButton: disableSaveButton
    };
  }
});